export function AnimalIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M17.09 3.39a2.5 2.5 0 013.5 3.488 10.05 10.05 0 00-3.5-3.488zm4.382 5.395a.998.998 0 00.278-.196 4.5 4.5 0 10-6.364-6.364.997.997 0 00-.203.292A9.99 9.99 0 0012 2c-1.059 0-2.08.165-3.037.47a1 1 0 00-.18-.245 4.5 4.5 0 10-6.364 6.364c.043.043.089.081.137.115A9.985 9.985 0 002 12c0 5.523 4.477 10 10 10s10-4.477 10-10a9.987 9.987 0 00-.528-3.215zM3.489 6.746a2.5 2.5 0 013.514-3.41 10.05 10.05 0 00-3.514 3.41zM11 10.5A1.5 1.5 0 118 10.5a1.5 1.5 0 013 0zm5 0a1.5 1.5 0 11-2.999 0 1.5 1.5 0 013 0zM13 14a1 1 0 10-2 0 1 1 0 01-1 1 1 1 0 100 2c.77 0 1.47-.289 2-.764A2.99 2.99 0 0014 17a1 1 0 100-2 1 1 0 01-1-1zm-9-2a8 8 0 1116 0 8 8 0 01-16 0z"
      ></path>
    </svg>
  );
}
